import axios from "axios";

export class LongPullClient{

    url;
    handlers;
    controller;
    sessionId;

    constructor(requestUrl, sessionId,handlers) {
        this.url = requestUrl || '';
        this.handlers = handlers;
        this.sessionId = sessionId;
    }

    open(){
        this.handlers.onOpen();
        this.controller = new AbortController();
        this._start();
    }

    async _start(){
        try {
            const {data, status} = await axios.get(this.url, {
                signal: this.controller.signal
            });
            console.log(data, status)
            if (status === 204) {
                this._start();
            } else if (status === 200) {
                this.handlers.onMessage(data);
                this._start();
            }
        }catch (e) {
            this.handlers.onError(e);
            this.handlers.onClose();
        }
    }

    stop(){
        this.controller.abort();
        this.handlers.onClose();
    }
}